<template>
  <div class="visit-distribution">
    <portal to="layout-nav-title">{{$t('wechatMiniProgram.analysis.visitDistribution')}}</portal>

    <el-date-picker
      v-model="endDate"
      type="date"
      @change="dateChange"
      :picker-options="pickerOptions"
      :placeholder="$t('wechatMiniProgram.analysis.pleaseSelectDate')">
    </el-date-picker>

    <PieEchart
      :title-text="$t('wechatMiniProgram.analysis.accessSourceSessionCnt')"
      :options="defaultOptions"
      :data="data['access_source_session_cnt']"/>
    <PieEchart
      :title-text="$t('wechatMiniProgram.analysis.accessStaytimeInfo')"
      :options="defaultOptions"
      :data="data['access_staytime_info']"/>
    <PieEchart
      :title-text="$t('wechatMiniProgram.analysis.accessDepthInfo')"
      :options="defaultOptions"
      :data="data['access_depth_info']"/>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import PieEchart from '@/components/echarts/pie-echart';
import moment from 'moment';

@Component({
  components: {
    PieEchart
  }
})
export default class VisitDistribution extends Vue {
  endDate = moment().add('days', -1);

  data = {
    access_source_session_cnt: [],
    access_staytime_info: [],
    access_depth_info: []
  }

  defaultOptions = {
    seriesName: this.$t('wechat_mini_program.analysis.sourceAnalysis'),
    seriesRadius: '40%',
    seriesCenter: ['30%', '50%']
  }

  get pickerOptions() {
    return {
      disabledDate: (time) => {
        return moment(time).diff(moment(new Date()), 'days') > -1;
      }
    }
  }

  mounted() {
    this.fetchData()
  }

  async fetchData(params = {}) {
    const data = await this.$request.get('/wechat_third_party_platform/data_analysis/visit_distribution', params);
    this.data.access_source_session_cnt = data.access_source_session_cnt || [];
    this.data.access_staytime_info = data.access_staytime_info || [];
    this.data.access_depth_info = data.access_depth_info || [];
  }

  dateChange() {
    if (this.endDate) {
      this.fetchData({ date: moment(this.endDate).format('YYYY-MM-DD') });
    } else {
      this.$message.warning('请先选择日期');
    }
  }
}

export const route = [
  {
    path: '/visit_distribution',
    name: 'visit_distribution',
    component: VisitDistribution,
    meta: {
      can: 'data_analyses.visit_distribution'
    }
  }
]
</script>

<style lang="scss" scoped>
.visit-distribution {
  margin: 20px 0 0 20px;
}
</style>
